const PENDING_ORDERS = "PENDING_ORDERS";
const PENDING_ORDERS_SUCCESS = "PENDING_ORDERS_SUCCESS";
const PENDING_ORDERS_FAILURE = "PENDING_ORDERS_FAILURE";
const CLEAR_PENDING_ORDERS = "CLEAR_PENDING_ORDERS";
const PendingOrdersSymbols = {
  PENDING_ORDERS_SUCCESS,
  PENDING_ORDERS_FAILURE,
  PENDING_ORDERS,
  CLEAR_PENDING_ORDERS,
};
export default PendingOrdersSymbols;
